import UltMeta, { Meta } from "./UltMeta/index";

class Type extends UltMeta {
    LIAN_YUN = new Meta(1, "志豪链云");
    SHIP = new Meta(2, "链云船务");
}

export const TYPE = new Type();
